import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],

      addItem: (product) => {
        const existingItem = get().items.find((item) => item.id === product.id);

        if (existingItem) {
          const updatedItems = get().items.map((item) => {
            if (item.id === product.id) {
              return {
                ...item,
                quantity: item.quantity + 1
              };
            }
            return item;
          });

          set({ items: updatedItems });
          return;
        }

        set({
          items: [
            ...get().items,
            {
              ...product,
              quantity: 1
            }
          ]
        });
      },

      removeItem: (productId) => {
        const updatedItems = get().items.filter((item) => item.id !== productId);
        set({ items: updatedItems });
      },

      updateQuantity: (productId, quantity) => {
        if (quantity <= 0) {
          const updatedItems = get().items.filter((item) => item.id !== productId);
          set({ items: updatedItems });
          return;
        }

        const updatedItems = get().items.map((item) => {
          if (item.id === productId) {
            return {
              ...item,
              quantity
            };
          }
          return item;
        });

        set({ items: updatedItems });
      },

      clearCart: () => {
        set({ items: [] });
      },

      getItemCount: () => {
        return get().items.reduce((total, item) => total + item.quantity, 0);
      },

      getCartTotal: () => {
        return get().items.reduce((total, item) => {
          return total + Number(item.price) * item.quantity;
        }, 0);
      }
    }),
    {
      name: 'aura-rosa-cart'
    }
  )
);

export const useWishlistStore = create(
  persist(
    (set, get) => ({
      items: [],

      addItem: (product) => {
        const exists = get().items.find((item) => item.id === product.id);
        if (exists) return;

        set({
          items: [...get().items, product]
        });
      },

      removeItem: (productId) => {
        const updatedItems = get().items.filter((item) => item.id !== productId);
        set({ items: updatedItems });
      },

      toggleItem: (product) => {
        const exists = get().items.find((item) => item.id === product.id);

        if (exists) {
          const updatedItems = get().items.filter((item) => item.id !== product.id);
          set({ items: updatedItems });
        } else {
          set({
            items: [...get().items, product]
          });
        }
      },

      isInWishlist: (productId) => {
        return get().items.some((item) => item.id === productId);
      },

      getWishlistCount: () => {
        return get().items.length;
      }
    }),
    {
      name: 'aura-rosa-wishlist'
    }
  )
);

export const useAuthStore = create((set) => ({
  customer: null,
  setCustomer: (customer) => set({ customer }),
  clearCustomer: () => set({ customer: null })
}));

